import { PanelRight } from 'lucide-react'
import { Button, IconButton } from './Button'

/** The one way to open a recipe preview, everywhere in the app. */
export function PreviewButton({
  onClick,
  iconOnly = false,
  className,
}: {
  onClick: () => void
  iconOnly?: boolean
  className?: string
}) {
  if (iconOnly) {
    return (
      <IconButton label="Preview" onClick={onClick} className={className}>
        <PanelRight size={14} aria-hidden />
      </IconButton>
    )
  }
  return (
    <Button variant="ghost" size="sm" onClick={onClick} className={className}>
      <PanelRight size={14} aria-hidden />
      Preview
    </Button>
  )
}
